<template>
  <responsive-modal v-model="visible" title="API do Google Analytics">
    <div class="product-google-analytics-modal">
      <div class="p-3 mb-5 border rounded border-information-400">
        <div class="d-flex gap-3">
          <bp-icon icon="fa fa-info-circle" class="text-information-500" />
          <span class="functional-1 text-information-700">
            Certifique-se que você tenha cadastrado o pixel (GA4) de
            rastreamento Google Analytics na {{ $config.get("title") }} antes de
            fazer a configuração da API.
          </span>
        </div>
      </div>

      <bp-input
        v-model="form.measurement_id"
        class="mt-3"
        label="ID da Métrica"
        placeholder="Digite o ID da métrica"
        :errors="errors.measurement_id"
      />

      <bp-input
        v-model="form.api_secret"
        class="mt-3"
        label="Chave secreta da API"
        placeholder="Digite a chave da API"
        :errors="errors.api_secret"
      />

      <footer-actions
        class="mt-6"
        :loading="loading"
        :disabled="!isValid"
        @submit="submit"
        @cancel="visible = false"
      />
    </div>
  </responsive-modal>
</template>

<script>
import { clearObject, formFields } from "@/functions/helpers";
import get from "lodash/get";
import { mapState } from "vuex";

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    integrationToEdit: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      ...formFields(["product_id", "api_secret", "measurement_id"]),
      loading: false,
      visible: false
    };
  },
  watch: {
    value(v) {
      this.visible = v;
    },
    visible(v) {
      this.$emit("input", v);
      if (!v) {
        this.clear();
      }
    },
    integrationToEdit(v) {
      if (v) {
        this.form = {
          ...this.form,
          ...v
        };
      }
    }
  },
  computed: {
    ...mapState("product", ["product"]),
    isValid() {
      return this.form.api_secret && this.form.measurement_id;
    }
  },
  methods: {
    clear() {
      this.form = {};
      this.$emit("clear-edit");
    },
    onSuccess() {
      this.loading = false;
      this.$message.success("A integração foi salva!");
      this.$emit("update-list");
      this.clear();
      this.visible = false;
    },
    submit() {
      this.loading = true;

      let data = {
        ...this.form,
        product_id: this.product.id
      };
      let action = "integration/postIntegration";

      if (this.integrationToEdit) {
        action = "integration/putIntegration";
      }

      this.$store
        .dispatch(action, clearObject(data))
        .then(this.onSuccess)
        .catch(error => {
          this.errors = error.response.data;
          let errorMsg = get(error, "response.data.message");
          this.$message.error(errorMsg ? errorMsg : "Erro ao salvar");
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.product-google-analytics-modal {
  position: relative;
  .close {
    position: absolute;
    top: 0;
    right: 0;
  }

  button {
    i {
      font-size: 28px;
    }
  }
}
</style>
